<style scoped>
@import "./index.css";
</style>

<template>
    <div>
        <Form ref="accountLogin" :model="accountLogin" :rules="accountLoginRule" :label-width="130">
            <FormItem label="请选择设备分类" prop="fenlei">
                <Select v-model="accountLogin.fenlei" @on-change="onChange" style="width:100%">
                    <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </FormItem>
            <FormItem label="请选择设备" prop="shebei">
                <Select v-model="accountLogin.shebei" style="width:100%">
                    <Option v-for="item in list2" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </FormItem>
            <FormItem prop="con" label="请详细说明">
                <Input v-model="accountLogin.con" type="textarea" :maxlength="200" :autosize="{minRows: 5,maxRows: 10}" placeholder="请输入您的具体地址，具体内容，方便维修人"></Input>
            </FormItem>
            <div style="margin-top: -20px; color:#666; font-size: 14px; text-align: right">
                {{accountLogin.con.length}}/200
            </div>
            <FormItem class="mb5">
                <Button long size="large" :loading="accountLogin.btnLoading" type="primary" @click="handleSubmit('accountLogin')">
                    <span>{{!accountLogin.btnLoading ? '提交' : '提交中...'}}</span>
                </Button>
            </FormItem>
        </Form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list : [],
            list2: [],
            list3: [],

            // +---------------
            // | 输入框数据
            // +---------------
            accountLogin: {
                fenlei: "",
                shebei: "",
                con: "",
                btnLoading: false
            },

            // +---------------
            // | 验证规则
            // +---------------
            accountLoginRule: {
                fenlei: [
                    {required: true, message: "请选择分类", trigger:"change"},
                ],
                shebei: [
                    {required: true, message: "请选择设备", trigger: "change"},
                ],
                con: [
                    {required: true, message: "请输入您的具体地址，具体内容，方便维修人", trigger: "blur"},
                ],
            }
        }
    },
    created() {
        const that = this;
        that.getCarList();
    },
    methods: {
        onChange(value){
            const that = this;
            that.list2 = [];
            that.accountLogin.shebei = '';
            that.list3.map(function(item,index){
                if(item.pid == value){
                    that.list2.push({
                        value:item.value.toString(),
                        label:item.label
                    })
                }
            })
        },
        //获取设备分类
        getCarList()
        {
            const that = this;
            that.$func.ajax('catList',{
                token :that.$func.getToken(),
                catPosition:3,
                flag:1
            },function (r) {
                if(!r.statusCode){
                    that.$func.msg(r.message,'error');
                }else{
                    r.type.map(function(item,index){
                        that.list.push({
                            label : item.catName,
                            value : item.catId
                        });
                        item.devices.map(function(item2,index2){
                            that.list3.push({
                                pid:item.catId,
                                value:item2.deviceId,
                                label:item2.deviceName
                            })
                        })
                    })
                }
            })
        },
        // +---------------
        // | 提交表单
        // +---------------
        handleSubmit(name) {
            const that = this;
            //验证表单
            that.$refs[name].validate(valid => {
                if (valid)
                {
                    that.$func.ajax('customerRepairSave',
                    {
                        token:that.$func.getToken(),
                        catId:that[name].fenlei,
                        deviceNo:that[name].shebei,
                        repairContent:that[name].con
                    },function(r){
                        if(!r.statusCode){
                            that.$func.msg(r.message,'error');
                        }else{
                            that.$func.msg('提交成功！');
                            //按钮状态关闭
                            that[name].btnLoading = false;
                            that.$refs[name].resetFields();
                            //跳转
                            that.$func.dsqOut(function() {
                                that.$emit('close');
                            },1.5);
                        }
                    })
                }
            });
        }
    }
};
</script>
